import getCurrentUser from './getCurrentUser'
import { SUPER_ADMIN } from '@/lib/constants/securityRoles'

const userIsSuperAdmin = () => {
  const user = getCurrentUser()

  return user &&
         user.securityRoles &&
         (user.securityRoles.includes(SUPER_ADMIN.name))
}

export default userIsSuperAdmin
